const items = [
  {
    cat: "塌房现场",
    title: "综艺常客 陆衍 被曝节目内外两副面孔",
    dek: "同场录制观众晒出 9 张对比图：台上暖男营业，台下冷言冷语，脱粉瞬间话题阅读破 2 亿。",
    heat: "86%",
    views: "2.4w 围观",
    img: "https://readdy.ai/api/search-image?query=Editorial%20celebrity%20gossip%20news%20photograph%2C%20a%20dark%20backstage%20corridor%20with%20a%20single%20cold%20stage%20light%2C%20empty%20makeup%20chair%20and%20mirror%20with%20bulbs%2C%20deep%20red%20and%20amber%20tone%2C%20grainy%2035mm%2C%20dramatic%20shadows%2C%20tabloid%20expose%20documentary%20mood&width=800&height=560&seq=gk-arch-01&orientation=landscape"
  },
  {
    cat: "口碑崩盘",
    title: "童星转型女演员 苏念 被指抄袭公益企划",
    dek: "原创意博主逐帧对比两版方案，重合度超九成，团队回应口径前后矛盾，口碑预警持续升级。",
    heat: "91%",
    views: "1.7w 围观",
    img: "https://readdy.ai/api/search-image?query=Editorial%20news%20documentary%20photograph%20of%20a%20desk%20littered%20with%20photocopied%20papers%2C%20red%20highlighter%20lines%20and%20a%20phone%20screen%20glow%2C%20warm%20desk%20lamp%2C%20dim%20room%2C%20grainy%20film%2C%20investigative%20mood%2C%20muted%20amber%20and%20ink%20tones&width=800&height=560&seq=gk-arch-02&orientation=landscape"
  },
  {
    cat: "脱粉瞬间",
    title: "顶流 顾言 机场冷脸甩手，老粉当场转黑",
    dek: "送机视频曝光全程零互动，粉丝隔空喊话 3 小时无人回应，一夜之间脱粉站号集体注销。",
    heat: "78%",
    views: "3.1w 围观",
    img: "https://readdy.ai/api/search-image?query=Candid%20editorial%20photography%20at%20an%20airport%20terminal%20at%20night%2C%20blurred%20crowd%20behind%20glass%2C%20lone%20figure%20walking%20away%2C%20harsh%20fluorescent%20and%20warm%20amber%20lights%2C%20grainy%20documentary%20style%2C%20lonely%20silhouette%2C%20press%20photo%20mood&width=800&height=560&seq=gk-arch-03&orientation=landscape"
  },
  {
    cat: "实锤复盘",
    title: "导演 程墨 考古旧采访，过往言论逐条翻车",
    dek: "三年前一场饭局录制被网友重新挖出，多个观点与今日人设正面冲突，实锤连线图全网疯转。",
    heat: "83%",
    views: "1.9w 围观",
    img: "https://readdy.ai/api/search-image?query=Vintage%20newsroom%20documentary%20photograph%2C%20old%20tape%20recorder%20and%20stacked%20film%20reels%20on%20wooden%20table%2C%20warm%20practical%20lamp%20light%2C%20dusty%20atmosphere%2C%20deep%20amber%20tones%2C%20grainy%20analog%20film%2C%20archival%20investigation%20mood&width=800&height=560&seq=gk-arch-04&orientation=landscape"
  },
  {
    cat: "塌房现场",
    title: "组合成员 池野 被拍到与经纪人越界画面",
    dek: "公开场合挽手依偎画面流出，公司火速「只是朋友」声明，网友整理时间线质疑公关文案。",
    heat: "88%",
    views: "2.8w 围观",
    img: "https://readdy.ai/api/search-image?query=Dim%20backstage%20editorial%20photograph%2C%20two%20blurred%20silhouettes%20apart%20at%20the%20edges%20of%20frame%2C%20empty%20concert%20venue%20glow%2C%20deep%20red%20and%20violet-free%20amber%20lighting%2C%20grainy%2035mm%2C%20tension%20and%20distance%2C%20documentary%20gossip%20mood&width=800&height=560&seq=gk-arch-05&orientation=landscape"
  },
  {
    cat: "口碑崩盘",
    title: "选秀出身 白允 被指舞台假唱实锤比对",
    dek: "粉丝逐帧扒出两处口型错位，音频波形对比图直指垫音过度，人设崩塌进入倒计时。",
    heat: "74%",
    views: "1.2w 围观",
    img: "https://readdy.ai/api/search-image?query=Editorial%20live%20concert%20photograph%20from%20the%20audience%2C%20a%20distant%20singer%20on%20stage%20under%20red%20and%20amber%20spotlights%2C%20silhouetted%20heads%20and%20raised%20phones%20in%20foreground%2C%20hazy%20lasers%2C%20grainy%20film%2C%20dark%20high%20contrast%20press%20shot&width=800&height=560&seq=gk-arch-06&orientation=landscape"
  },
];

export default function CollapseArchive() {
  return (
    <section id="archive" className="w-full bg-background-100/60 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        {/* 区头 */}
        <div className="mb-6 flex flex-col gap-3 md:mb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-1.5 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              Archive · 今日塌房档案
            </p>
            <h3 className="font-display text-2xl font-black text-foreground-950 md:text-[34px] md:leading-tight">
              呱呱黑料塌房档案<span className="text-primary-600">，</span>本周在追
            </h3>
            <p className="mt-1.5 max-w-2xl text-sm text-foreground-600">
              每人一个档案页，塌房现场、实锤来源、脱粉瞬间按时间顺序收好，欢迎翻查。
            </p>
          </div>
          <a
            href="#feed"
            className="inline-flex w-fit cursor-pointer items-center whitespace-nowrap rounded-full border border-foreground-950/15 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            更多档案进入快讯流
            <i className="ri-arrow-right-line ml-1.5"></i>
          </a>
        </div>

        {/* 图文卡网格 */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {items.map((it) => (
            <article
              key={it.title}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 shadow-card transition-shadow hover:shadow-lift"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={it.img}
                  alt={`呱呱黑料${it.title}塌房档案配图`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/80 px-2.5 py-1 text-[11px] font-bold text-background-50 backdrop-blur">
                  <i className="ri-focus-3-fill text-accent-300"></i>
                  {it.cat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h4 className="text-[15px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                  {it.title}
                </h4>
                <p className="mt-2 line-clamp-3 flex-1 text-[13px] leading-relaxed text-foreground-600">
                  {it.dek}
                </p>
                <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <span className="relative inline-flex h-2 w-2">
                      <span className="gk-pulse absolute inline-flex h-full w-full rounded-full bg-primary-400"></span>
                      <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
                    </span>
                    崩盘指数 <b className="text-foreground-900">{it.heat}</b>
                  </span>
                  <span className="text-xs text-foreground-400">{it.views}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}